import { render, staticRenderFns } from "./CaseMedicationDetails.vue?vue&type=template&id=2a2337fb&scoped=true&"
import script from "./CaseMedicationDetails.vue?vue&type=script&lang=js&"
export * from "./CaseMedicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./CaseMedicationDetails.vue?vue&type=style&index=0&id=2a2337fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2337fb",
  null
  
)

export default component.exports